import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../auth/firebase";

export const useAuthUser = () => {
  const [user, setUser] = useState(undefined); // 👈 important

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        setUser({
          id: firebaseUser.uid,
          email: firebaseUser.email,
          name: firebaseUser.displayName,
          photo: firebaseUser.photoURL,
          type: "google",
        });
      } else {
        setUser({ type: "guest" });
      }
    });

    return () => unsub();
  }, []);

  return user;
};
